import type { ElementType } from 'react';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import ThumbsUpDownOutlinedIcon from '@mui/icons-material/ThumbsUpDownOutlined';
import { Stack, Typography } from '@mui/material';
import { Feedbacks } from './components/feedbacks';
import { FilledIcon } from './components/filled-icon';
import { Manual } from './components/manual';
import { Occupations } from './components/occupations';
import { SkillsProvider } from './context/skills';
import { AiChip } from '@/components/shared/ai-chip';
import { PageContainer } from '@/components/shared/page-container';
import { PageHeader } from '@/components/shared/page-header';
import { useSetTitle } from '@/hooks/use-set-title';

const title = 'Gerenciar habilidades';

interface SectionTitleProps {
  title: string;
  iaChip?: boolean;
  icon: ElementType;
}

const SectionTitle = ({ title, iaChip = true, icon }: SectionTitleProps) => (
  <Stack direction="row" alignItems="center" gap={1}>
    <FilledIcon icon={icon} />
    <Stack direction="row" alignItems="center" flexWrap="wrap" gap={1} flex={1}>
      <Typography variant="h2">{title}</Typography>
      {iaChip && <AiChip />}
    </Stack>
  </Stack>
);

export const SkillManagement = () => {
  useSetTitle(title);

  return (
    <SkillsProvider>
      <PageContainer>
        <PageHeader
          title={title}
          description="Gerencie suas habilidades à partir das informações fornecidas na plataforma. Quanto mais informações, mais habilidades e melhores recomendações para o seu desenvolvimento."
        />
        <Stack gap={3} mt={6}>
          <SectionTitle title="Feedbacks" icon={ThumbsUpDownOutlinedIcon} />
          <Feedbacks />

          <Stack gap={3} my={3}>
            <SectionTitle
              title="Objetivo e Cargo"
              icon={AssignmentIndOutlinedIcon}
            />
            <Occupations />
          </Stack>

          <SectionTitle
            title="Adicionadas manualmente"
            icon={AddBoxOutlinedIcon}
            iaChip={false}
          />
          <Manual />
        </Stack>
      </PageContainer>
    </SkillsProvider>
  );
};
